import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Avatar, Chip, NakedButton, Text, usePopoverDialog } from '@frontend/design-system';
import { Option } from '.';

type CustomInputProps = {
  disabled?: boolean;
  error?: string;
  placeholder?: string;
  showAvatar?: boolean;
  value?: Option[];
  onRemove: (id: string) => void;
  getTriggerProps: ReturnType<typeof usePopoverDialog>['getTriggerProps'];
};

// @TODO: Implement custom input as per design
export const CustomInput = ({
  disabled = false,
  error,
  placeholder = '',
  showAvatar = false,
  value,
  onRemove,
  getTriggerProps,
}: CustomInputProps) => {
  return (
    <div data-testid='multi-view-combobox-custom-input'>
      <NakedButton disabled={disabled} {...getTriggerProps()} css={customInputStyles(disabled)}>
        <Icon name='search' color={disabled ? 'disabled' : 'default'} css={{ flexShrink: 0 }} />
        {!!value?.length ? (
          value.map(({ id, label }) => (
            <Chip
              key={id}
              variant={disabled ? 'disabled' : 'primary'}
              css={{ color: theme.colors.neutral90, maxWidth: 'calc(100% - 32px)' }} // 32px for chip padding and flex gap between icon and chip
              leftElement={showAvatar ? <Avatar name={label} size='xxs' /> : undefined}
              rightElement={
                !disabled && (
                  <Icon
                    name='x-tiny'
                    color='light'
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemove(id);
                    }}
                  />
                )
              }
            >
              {label}
            </Chip>
          ))
        ) : (
          <Text color='subdued'> {placeholder}</Text>
        )}
      </NakedButton>
      {error && (
        <Text color='error' size='small' css={{ marginTop: theme.spacing(1) }}>
          {error}
        </Text>
      )}
    </div>
  );
};

const customInputStyles = (disabled: boolean) =>
  css({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    border: `1px solid ${theme.colors.neutral20}`,
    borderRadius: theme.borderRadius.medium,
    width: '100%',
    minWidth: 180,
    cursor: disabled ? 'not-allowed' : 'pointer',
  });
